module.exports = __webpack_public_path__ + "static/media/star-outline.859b88c1.svg";